import WidgetCard from "@/components/cards/widget-card";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { defaultData } from "@/data/tan-table-data";
import { defaultColumns } from "./column";

export type PersonType = (typeof defaultData)[number];

export default function TableColumnPinning() {
    const { table, setData } = useTanStackTable<PersonType>({
        tableData: defaultData,
        columnConfig: defaultColumns,
        options: {
            initialState: {
                columnPinning: {
                    left: ["id"],
                    right: ["actions"],
                },
                pagination: {
                    pageIndex: 0,
                    pageSize: 6,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <WidgetCard title="Column Pinning" className="space-y-4">
            <Table
                table={table}
                variant="modern"
                classNames={{
                    rowClassName: "last:border-b-transparent",
                }}
            />
        </WidgetCard>
    );
}
